import * as React from 'react';
import {
  Image, Row, Col, Loader, Button
} from '@thd-olt-component-react/core-ui';
import { func, bool } from 'prop-types';
import { WelcomeCardHeader } from '../WelcomeCardHeader/WelcomeCardHeader';
import './WelcomeCardErrorPage.scss';
import '../../common/style/WelcomeCardGlobal.scss';

const WelcomeCardErrorPage = (props) => {
  const { handleOnClick, cardLoaded } = props;

  const RefreshButton = () => {
    return (
      <div className="WelcomeCardErrorPage__refreshMain ">
        <Image
          width="24px"
          height="24px"
          src="https://assets.thdstatic.com/images/v1/loyaltyBenefits/refresh.svg"
          alt="refresh"
        />
        <Button
          link
          transparent
          underline="true"
          className="WelcomeCardErrorPage__subLink"
          onClick={handleOnClick}
        >Refresh
        </Button>
      </div>
    );
  };

  const RefreshLabel = () => {
    return (
      <div className="Icon">
        <Col>
          <Image
            width="45px"
            height="45px"
            src="https://assets.thdstatic.com/images/v1/loyaltyBenefits/pro-extra-perk.svg"
            alt="pro-extra-perk"
          />
        </Col>
        <Col className="WelcomeCardErrorPage__label">
          Check Back For Your Loyalty Status
        </Col>
      </div>
    );
  };

  const SpinnerCard = () => {
    return (
      <div className="WelcomeCardErrorPage__spinnerContainer">
        <Loader active className="WelcomeCardErrorPage__cardLoader" />
      </div>
    );
  };

  return (
    <Col className="WelcomeCardErrorPage__welcomeErrorCard">
      <Row>
        <div className="hidden-xl-up  col__12-12">
          <div className="col__6-12 WelcomeCardErrorPage__errorProLogo11">
            <WelcomeCardHeader />
          </div>
          {cardLoaded && <div className="col__6-12"><RefreshButton /></div>}
        </div>
        <div className="hidden-lg-down col__12-12 WelcomeCardErrorPage__errorProLogo">
          <WelcomeCardHeader />
          <div className="WelcomeCardErrorPage__loaderDesktopMain">
            {cardLoaded ? (
              <><RefreshLabel />
                <RefreshButton />
              </>
            ) : <SpinnerCard />}
          </div>
        </div>
        <div className="WelcomeCardErrorPage__loaderMain hidden-xl-up ">
          {cardLoaded ? <RefreshLabel /> : <SpinnerCard />}
        </div>
      </Row>
    </Col>
  );
};

WelcomeCardErrorPage.propTypes = {
  handleOnClick: func,
  cardLoaded: bool
};

WelcomeCardErrorPage.defaultProps = {
  handleOnClick: () => { },
  cardLoaded: true
};

export { WelcomeCardErrorPage };
